import { useSearchParams } from 'react-router-dom'

/** `?email=` scopes every legacy per-user admin page to one end-user
 * (admin spec: "End-user email is passed as query param `email`"). */
export function useEmailParam(): string {
  const [params] = useSearchParams()
  return params.get('email') ?? ''
}

export function useQueryParam(name: string): string {
  const [params] = useSearchParams()
  return params.get(name) ?? ''
}
